import { render, staticRenderFns } from "./FailureParts.vue?vue&type=template&id=67b59656"
import script from "./FailureParts.vue?vue&type=script&lang=js"
export * from "./FailureParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports